import React, { useState, useEffect } from "react";
import HomeHeader from "./HomeHeader";
import About from "./About";
import HomeSlide from "./HomeSlide";

import Card from "./Card";
import DivisionPage from "./DivisionPage";
import Footer from "./Footer";
import api from "../api/api";


import "./Styles/home.css";

const Home = () => {


  return (
    <div>
      <div className="headerderty">
        <HomeHeader />
      </div>

      
      <Card />
      <DivisionPage />

      <div className="homeeeSlide">
        <HomeSlide />
      </div>

      <div className="homeeeSlide">
        <About />
      </div>

      

<Footer />
    </div>
  );
};

export default Home;
